<template>
  <h2>취소내역</h2>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  data () {
    return {
      currentPage: 1,
    }
  },
  methods: {

  }
}
</script>